module.exports = __webpack_public_path__ + "img/virtual_account.01e31ae7.svg";